import { Ban } from 'lucide-react';

/**
 * Bandeau affiché en haut du flux de contractualisation quand le devis est abandonné
 * (statusCode "AB" / statusCategory "Cancelled"). Partagé par les flux emprunteur et
 * générique (CBNO / chômage / GLI). Volontairement non-dismissible : c'est un état
 * persistant, pas une notification.
 */
export const CancelledQuoteBanner = () => (
  <div
    role="alert"
    className="flex items-start gap-3 rounded-lg border border-red-200 bg-red-50 p-4"
  >
    <Ban aria-hidden="true" className="w-5 h-5 mt-0.5 text-red-600 flex-shrink-0" />
    <div className="flex flex-col">
      <p className="font-semibold text-red-800">Devis abandonné</p>
      <p className="text-sm text-red-700">
        Ce devis a été annulé. Toute modification est désactivée.
      </p>
    </div>
  </div>
);
